export default __webpack_public_path__ + "static/media/sort-descending.75cf48c5.svg";